import React from 'react'
// libs
import styled from 'styled-components'
// hocs
import { withDropzone } from 'hocs/index'
// view components
import Activity from 'containers/Activities/components/Activity'
import CreateCommentForm from 'components/FormElements/ReduxForm/Forms/CreateCommentForm'
// constants
import { Forms } from 'constants/forms'
// types
import { DropzoneRef } from 'react-dropzone'
// context
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'
import { ActivityBLContext } from 'containers/Activities/layers/BL/Activity'
// utils
import { isEmpty } from 'lodash'

// styled
const FormWrapper = styled.div`
  margin-bottom: 8px;
`

// types
interface IIncomingProps {
  open: DropzoneRef
}

const SubActivitiesListContent: React.FunctionComponent<IIncomingProps> = ({ open }) => {
  const { logs } = React.useContext(ActivitiesListAPIContext)
  const { shouldShowSubCommentForm, handleCloseSubCommentForm } = React.useContext(ActivityBLContext)

  return (
    <>
      {shouldShowSubCommentForm && (
        <FormWrapper>
          <CreateCommentForm
            open={open}
            isSubComment
            form={Forms.CREATE_SUB_COMMENT_FORM}
            handleCloseForm={handleCloseSubCommentForm}
          />
        </FormWrapper>
      )}

      {!isEmpty(logs) &&
        logs.map((item) => {
          return item.map((component) => {
            if (Array.isArray(component)) {
              return component.map((log) => {
                return <Activity key={log.id} activity={log} />
              })
            }
          })
        })}
    </>
  )
}

export default withDropzone(SubActivitiesListContent)
